import {
  WSActionsButton,
  WSCard,
  WSElement,
  WSFlexBox,
  WSList,
  WSProgressBar,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { BulkActionProgress } from "../types";

type Props = {
  title: string;
  progress: BulkActionProgress;
  description?: string;
  action?: WSActionsButton;
};

export const BulkActionProgressBanner: React.FC<Props> = props => {
  const percent =
    props.progress.total > 0
      ? Math.round((props.progress.processed / props.progress.total) * 100)
      : 0;

  return (
    <WSCard
      header={{
        label: {
          avatar: {
            type: "icon",
            icon: "loader",
            size: "M",
            color: "blue400",
            colorBackground: "blue50"
          },
          text: `${props.title}:`
        }
      }}
      divider="bottom"
      actions={
        props.action
          ? { alignment: "left", buttons: [props.action] }
          : undefined
      }
    >
      <WSList gap="S">
        <WSProgressBar percent={percent} theme="info" />

        <WSFlexBox alignItems="center" justify="space-between" gap="S">
          <WSText.ParagraphSm color="gray500">
            {props.description ??
              `Processing ${props.progress.processed.toLocaleString()} of ${props.progress.total.toLocaleString()}`}
          </WSText.ParagraphSm>
          <WSElement>
            <WSText.ParagraphSm color="gray500">{percent}%</WSText.ParagraphSm>
          </WSElement>
        </WSFlexBox>
      </WSList>
    </WSCard>
  );
};
